import styled from 'styled-components';
import colors from '../../../styles/colors';

const Container = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  background-color: ${colors.base.gamma};
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const HeaderTitle = styled.h2`
  font-weight: 500;
`;

const HeaderDescription = styled.p`
  color: ${colors.base.beta};
`;

const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  background: white;
  padding: 8px;
  border-radius: 4px;
`;

const ButtonContainer = styled.div`
  margin-bottom: 20px;
  display: flex;
  gap: 16px;
`;

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const UserCountDisplay = styled.div`
  font-weight: 500;
  display: flex;
  align-items: center;
`;

export {
  Container,
  HeaderContainer,
  DetailsContainer,
  HeaderTitle,
  ButtonContainer,
  LoadingContainer,
  HeaderDescription,
  UserCountDisplay,
};
